import { Box, Fade, LinearProgress, Typography } from "@mui/material";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";

export const OrdersLoading = () => (
  <Box mb={2}>
    <LinearProgress sx={{ borderRadius: 1 }} />
    <Typography variant="body2" color="#6b7280" mt={1}>
      טוען הזמנות...
    </Typography>
  </Box>
);

export const OrdersEmptyMessage = ({ message }) => (
  <Fade in timeout={600}>
    <Box textAlign="center" py={6}>
      <PauseCircleOutlineIcon sx={{ fontSize: 64, color: "#d1d5db", mb: 2 }} />
      <Typography variant="h6" color="#6b7280">
        {message}
      </Typography>
    </Box>
  </Fade>
);

// Empty-result text; an order opened from an email link that isn't listed
// gets its own explanation.
export const noMatchesMessage = (linkedOrdname, searchText) =>
  linkedOrdname && searchText === linkedOrdname
    ? `הזמנה ${linkedOrdname} כבר אינה בסטטוס השהיית סחר, או שאינה משויכת אליך`
    : "לא נמצאו הזמנות התואמות את הסינון";
